import { useApiQuery } from '@BUP/hooks/useApiQuery'

export const useGetNotifications = (options = {}) => {
  const query = useApiQuery(
    ['bup-modes-notifications'],
    'schools',
    '/current-enrollment/notifications',
    options,
    { authenticated: true, version: 3 }
  )

  return {
    loadingNotifications: query.isLoading,
    isFetchingNotifications: query.isFetching,
    notifications: query.data,
    errorNotifications: query.isError ? query.error : null,
    getNotifications: query.refetch
  }
}
